/* Rx HUMAN RESOURCE — product description progressive enhancement
   Added 2026-09-13.

   Two jobs:
   1. Tag the origin line so it can be set apart typographically.
   2. Fold everything from the first <h3> onward into disclosure rows, so the
      page opens on the lede and the specs, story and FAQ are one tap away.

   The content stays in the DOM in full. It is indexed normally and remains
   valid for FAQPage structured data, because an accordion is user-accessible
   rather than hidden.

   No dependencies. Idempotent. If it does not run, the description renders in
   full and nothing breaks. */
(function () {
  'use strict';

  var LABELS = { 'frequently asked questions': 'FAQ' };
  var ORIGIN = /^\s*designed in\b[\s\S]*\bmade in\b/i;

  function run() {
    var root = document.querySelector('.product-page .description');
    if (!root || root.dataset.rxEnhanced) return;

    var rte = root.querySelector('.rte');
    if (!rte) return;

    /* Matched on content rather than position, so it survives the paragraphs
       being reordered in the Shopify editor. */
    Array.prototype.forEach.call(rte.querySelectorAll('p'), function (p) {
      if (ORIGIN.test(p.textContent)) p.classList.add('rx-origin');
    });

    var nodes = Array.prototype.slice.call(rte.children);
    var firstH3 = -1;
    for (var n = 0; n < nodes.length; n++) {
      if (nodes[n].tagName === 'H3') { firstH3 = n; break; }
    }
    if (firstH3 === -1) { root.dataset.rxEnhanced = '1'; return; }

    var groups = [];
    for (var i = firstH3; i < nodes.length; i++) {
      if (nodes[i].tagName === 'H3') {
        groups.push({ heading: nodes[i], contents: [] });
      } else if (groups.length) {
        groups[groups.length - 1].contents.push(nodes[i]);
      }
    }
    if (!groups.length) { root.dataset.rxEnhanced = '1'; return; }

    var frag = document.createDocumentFragment();

    groups.forEach(function (g) {
      var raw = (g.heading.textContent || '').trim();
      var label = LABELS[raw.toLowerCase()] || raw;

      var section = document.createElement('section');
      section.className = 'blocks accordion rx-acc';

      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.className = 'dropdown-caret';
      summary.textContent = label;

      var body = document.createElement('div');
      body.className = 'text rte';
      g.contents.forEach(function (el) { body.appendChild(el); });

      /* Turn "<li><strong>Key:</strong> value</li>" into a two-column row. */
      Array.prototype.forEach.call(body.querySelectorAll('ul'), function (ul) {
        var rows = Array.prototype.slice.call(ul.children);
        var convertible = rows.length > 0 && rows.every(function (li) {
          var s = li.querySelector('strong, b');
          return s && /:\s*$/.test(s.textContent.trim());
        });
        if (!convertible) return;
        ul.classList.add('rx-specs');
        rows.forEach(function (li) {
          var strong = li.querySelector('strong, b');
          var key = strong.textContent.trim().replace(/:\s*$/, '');
          strong.parentNode.removeChild(strong);
          var value = li.textContent.trim();
          li.textContent = '';
          var k = document.createElement('span');
          k.className = 'k';
          k.textContent = key;
          var v = document.createElement('span');
          v.className = 'v';
          v.textContent = value;
          li.appendChild(k);
          li.appendChild(v);
        });
      });

      details.appendChild(summary);
      details.appendChild(body);
      section.appendChild(details);
      frag.appendChild(section);

      g.heading.parentNode.removeChild(g.heading);
    });

    /* Insert as siblings after the description block so they pick up the
       theme's own accordion styling. */
    if (root.parentNode) root.parentNode.insertBefore(frag, root.nextSibling);

    root.dataset.rxEnhanced = '1';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Shopify theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', run);
})();
